import { el, nl } from 'date-fns/esm/locale';
import { registerLocale } from 'react-datepicker';

registerLocale('nl', nl);
registerLocale('en', el);
